import React, { useState, useEffect, useCallback } from "react";
import MateriaPrimaFormulario from "./MateriaPrimaFormulario";
import MateriaPrimaTabela from "./MateriaPrimaTabela";
import { Button, Modal, Box, Paper, Snackbar } from "@mui/material";
import PermissionGate from "../CadastroPerfilUsuario/PermissionGate";
import URLManager from "../funcionalidadeNavbar/URLManager";

const MateriaPrima = () => {
  const _url =URLManager.getBaseURL()

  // Objeto MateriaPrima
  const materiaPrima = {
    id: 0,
    descricao: '',
    cor: '',
    custo: '',
    codigoMateria: '',
    umSigla: '',
    saldoEstoque: '',
    status: '',
    idEmpresa: 0,
    idFornecedor: 0,
  };


  const [popperMessage, setPopperMessage] = useState('');
  const [btnMateria, setBtnMateria] = useState(true);
  const [materiaPrimas, setMateriaPrimas] = useState([]);
  const [objmateriaPrima, setObjMateriaPrima] = useState(materiaPrima);
  const [fornecedores, setFornecedores] = useState([]);
  const [fornecedorSelecionar, setFornecedorSelecionar] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openFornecedorModal, setOpenFornecedorModal] = useState(false);

  // Estado para armazenar as matérias-primas filtradas
  const [materiasPrimasFiltradas, setMateriasPrimasFiltradas] = useState(materiaPrimas);

  const filtrarMateriasPrimas = (descricao) => {

    if (!descricao) {
      // Se a descrição estiver vazia, lista todas as matérias-primas
      setMateriasPrimasFiltradas(materiaPrimas);
    } else {
      // Se houver uma descrição, filtra as matérias-primas
      const resultado = materiaPrimas.filter((obj) =>
        obj.descricao.toLowerCase().includes(descricao.toLowerCase())
      );
      setMateriasPrimasFiltradas(resultado);
    }
  };


  const handleOpenModal = () => {
    limparMateriaPrima();
    setOpenModal(true);
  }

  const handleCloseModal = () => {
    limparMateriaPrima();
    setOpenModal(false);
  }

  const handleOpenFornecedorModal = () => {
    setOpenFornecedorModal(true);
  };

  const handleCloseFornecedorModal = () => {
    setOpenFornecedorModal(false);
    setFornecedorSelecionar(null);
  };



  // Adicione este estado para controle do Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // Função para mostrar o popper com uma mensagem e fechar após 3 segundos
  const mostrarMensagem = (mensagem) => {
    setPopperMessage(mensagem);
    setSnackbarOpen(true);
    setTimeout(() => setSnackbarOpen(false), 3000);
  };

  <Snackbar
    open={snackbarOpen}
    autoHideDuration={3000}
    onClose={() => setSnackbarOpen(false)}
    message={popperMessage}
  />

  const carregarFornecedores = useCallback(() => {
    fetch(`${_url}/fornecedor/listar`,{
      headers: {
        'Content-Type': 'application/json',
        Accept: "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
      },
    }) 
      .then((response) => response.json())
      .then((dadosFornecedores) => setFornecedores(dadosFornecedores))
      .catch((error) => console.error('Erro ao carregar fornecedores:', error));
  }, [_url]);

  //função para atualizar a Tabela de Materia prima(reload)
  const carregarMateriaPrima = useCallback(() => {
    fetch(`${_url}/materiaPrima/listar`,{
      headers: {
        'Content-Type': 'application/json',
        Accept: "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
      },
    })
      .then((retorno) => retorno.json())
      .then((dadosFornecedor) => {
        console.log("Dados carregados:", dadosFornecedor);
        setMateriasPrimasFiltradas(dadosFornecedor);

      })
      .catch((error) => console.error('Erro ao carregar matéria-prima:', error));
  }, [_url]);

  // Função para exibir as informações do fornecedor
  const exibirFornecedor = (idFornecedor) => {
    const fornecedor = fornecedores.find((p) => p.id === Number(idFornecedor));
    if (fornecedor) {
      setFornecedorSelecionar(fornecedor);
      handleOpenFornecedorModal();
    } else {
      mostrarMensagem('Fornecedor não encontrado');

    }
  };


  // Obtendo os dados do formulário
  const digitar = (e) => {
    const { name, value } = e.target;
    setObjMateriaPrima({
      ...objmateriaPrima,
      [name]: name === 'saldoEstoque' ? (value === '' ? '' : parseFloat(value)) : value
    });
  };

  // useEffect MateriaPrima
  useEffect(() => {
    fetch(`${_url}/materiaPrima/listar`,{

    headers: {
      'Content-Type': 'application/json',
      Accept: "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
    },
  })
      .then((retorno) => retorno.json())
      .then((retorno_convertido) =>
        setMateriaPrimas(retorno_convertido));
  }, [_url]);

  //Remover materia prima
  // Remover Fornecedor
  const remover = () => {
    fetch(`${_url}/materiaPrima/remover/${objmateriaPrima.id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
      },
    })
      .then((retorno) => retorno.json())
      .then((retorno_convertido) => {
        mostrarMensagem(retorno_convertido.mensagem);
        let vetorTemp = [...materiaPrimas];
        let indice = vetorTemp.findIndex((p) => p.id === objmateriaPrima.id);
        vetorTemp.splice(indice, 1);
        setMateriaPrimas(vetorTemp);
        mostrarMensagem("Materia Prima removido")
        limparMateriaPrima();
        carregarMateriaPrima();
        handleCloseModal();

      });
  };



  // Cadastrar MateriaPrima
  const cadastrarMateriaPrima = () => {
    if (!objmateriaPrima.descricao || !objmateriaPrima.cor || !objmateriaPrima.custo || !objmateriaPrima.codigoMateria || !objmateriaPrima.idFornecedor || !objmateriaPrima.umSigla) {
      mostrarMensagem("Preencha todos os campos obrigatórios.");
      return;
    }
    
    // Prepare payload: ensure idEmpresa is just a number
    const { id, idEmpresa, ...payload } = objmateriaPrima;
    payload.idFornecedor = objmateriaPrima.idFornecedor;
    
    // If idEmpresa is 0 or null/undefined, do not include it - backend will use authenticated user's company
    if (idEmpresa && idEmpresa !== 0) {
      payload.idEmpresa = typeof idEmpresa === 'object' ? idEmpresa.id : idEmpresa;
    } else {
      payload.idEmpresa = 1; // Default to 1 if not provided
    }

    fetch(`${_url}/materiaPrima/${objmateriaPrima.idFornecedor}`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        Accept: "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
      },
    })
      .then((retorno) => retorno.json())
      .then((retorno_convertido) => {
        if (retorno_convertido.mensagem) {
          mostrarMensagem(retorno_convertido.mensagem);
        } else {
          setMateriaPrimas([...materiaPrimas, retorno_convertido]);
          mostrarMensagem('Matéria-prima cadastrada com sucesso!');
          limparMateriaPrima();
          carregarMateriaPrima();
          handleCloseModal();

        }
      });
  };

  // Inativar MateriaPrima
  const inativar = () => {

    fetch(`${_url}/materiaPrima/inativar/${objmateriaPrima.id}`, {
      method: 'POST',
      body: JSON.stringify(objmateriaPrima),
      headers: {
        'Content-Type': 'application/json',
        Accept: "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
      },
    })
      .then((retorno) => retorno.json())
      .then((retorno_convertido) => {
        if (retorno_convertido.mensagem !== undefined) {
          mostrarMensagem(retorno_convertido.mensagem);
        } else {
          //setMateriaPrimas([...materiaPrimas, retorno_convertido]);
          mostrarMensagem('Matéria-prima inativada');
          carregarMateriaPrima();
          limparMateriaPrima();
          handleCloseModal();

        }
      });
  };

  // Ativar MateriaPrima
  const ativar = () => {

    fetch(`${_url}/materiaPrima/ativar/${objmateriaPrima.id}`, {
      method: 'POST',
      body: JSON.stringify(objmateriaPrima),
      headers: {
        'Content-Type': 'application/json',
        Accept: "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
      },
    })
      .then((retorno) => retorno.json())
      .then((retorno_convertido) => {
        if (retorno_convertido.mensagem !== undefined) {
          alert(retorno_convertido.mensagem);
        } else {
          //setMateriaPrimas([...materiaPrimas, retorno_convertido]);
          mostrarMensagem('Matéria-prima ativada');
          carregarMateriaPrima();
          limparMateriaPrima();
          handleCloseModal();
        }
      });
  };

  // Alterar MateriaPrima
  const alterarMateriaPrima = () => {
    console.log('Dados a serem enviados:', objmateriaPrima);
    
    // Prepare payload: ensure idEmpresa is just a number
    const { idEmpresa, ...payload } = {
      id: objmateriaPrima.id,
      descricao: objmateriaPrima.descricao,
      cor: objmateriaPrima.cor,
      custo: objmateriaPrima.custo,
      codigoMateria: objmateriaPrima.codigoMateria,
      idFornecedor: objmateriaPrima.idFornecedor,
      umSigla: objmateriaPrima.umSigla,
      saldoEstoque: objmateriaPrima.saldoEstoque
    };
    
    // If idEmpresa is 0 or null/undefined, do not include it - backend will use authenticated user's company
    if (objmateriaPrima.idEmpresa && objmateriaPrima.idEmpresa !== 0) {
      payload.idEmpresa = typeof objmateriaPrima.idEmpresa === 'object' ? objmateriaPrima.idEmpresa.id : objmateriaPrima.idEmpresa;
    } else {
      payload.idEmpresa = 1; // Default to 1 if not provided
    }
    
    fetch(`${_url}/materiaPrima/alterar/${objmateriaPrima.id}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        Accept: "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.mensagem) {
          alert(data.mensagem);
        } else {
          const updatedMateriaPrimas = materiaPrimas.map(materiaPrima =>
            materiaPrima.id === objmateriaPrima.id ? { ...materiaPrima, ...objmateriaPrima } : materiaPrima
          );
          setMateriaPrimas(updatedMateriaPrimas);
          mostrarMensagem('Matéria-prima alterada com sucesso!');
          carregarMateriaPrima();
          limparMateriaPrima();
          handleCloseModal();
        }
      })
      .catch(error => {
        console.error('Erro ao alterar matéria-prima:', error);
        mostrarMensagem('Erro ao alterar matéria-prima');
      });
  };


  // Limpar Materia Prima
  const limparMateriaPrima = () => {
    setObjMateriaPrima(materiaPrima);
    setBtnMateria(true);

  };

  // Selecionar MateriaPrima
  const selecionarMateria = (id) => {
    const materiaSelecionada = materiaPrimas.find(mp => mp.id === id);

    if (!materiaSelecionada) {
      mostrarMensagem("Matéria-prima não encontrada");
      return;
    }
    console.log("Dados da matéria selecionada:", materiaSelecionada);

    setObjMateriaPrima({
      ...materiaPrima,
      ...materiaSelecionada,
      idFornecedor: materiaSelecionada.idFornecedor?.id || materiaSelecionada.idFornecedor
    });
    setBtnMateria(false);
    setOpenModal(true);
  };

  useEffect(() => {
    carregarMateriaPrima();
    carregarFornecedores();
  }, [carregarMateriaPrima,carregarFornecedores]);

  return (
    <div>
      <div className="toolbar-inline toolbar-center">
        <PermissionGate permissions={["materiaPrimaCadastrar"]}>
          <Button variant="contained" onClick={handleOpenModal}>
            Cadastrar Matéria Prima
          </Button>
        </PermissionGate>
      </div>

      {/* Modal com o formulário de cadastro */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50% )',
            width: 450,
            maxHeight: '85vh',
            overflowY: 'auto',
            p: 3,
          }}
        >
          <Paper style={{
            padding: '15px',
            color: '#333',
            textAlign: 'center',
            fontSize: '16px',
            borderRadius: '20px',
            background: 'rgba(255, 255, 255, 0.98)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div className="modal-title">
              {btnMateria ? 'Cadastrar Matéria Prima' : 'Editar Matéria Prima'}
            </div>

            <MateriaPrimaFormulario
              botao={btnMateria}
              eventoTeclado={digitar}
              cadastrarMateriaPrima={cadastrarMateriaPrima}
              obj={objmateriaPrima}
              alterarMateriaPrima={alterarMateriaPrima}
              fornecedores={fornecedores}
              ativar={ativar}
              inativar={inativar}
              cancelar={limparMateriaPrima}
              remover={remover}
              carregarFornecedores={carregarFornecedores}
              filtrar={filtrarMateriasPrimas}
            />
            
            <div className="modal-buttons">
              <button onClick={handleCloseModal} className='modal-button modal-button-close'>
                Fechar
              </button>
            </div>
          </Paper>
        </Box>
      </Modal>

      <MateriaPrimaTabela
        vetor={materiasPrimasFiltradas}
        selecionar={selecionarMateria}
        exibirFornecedor={exibirFornecedor}
        filtrar={filtrarMateriasPrimas}
        vetrores={materiaPrimas}

      />
      <Modal open={openFornecedorModal} onClose={handleCloseFornecedorModal}>
        <Box
          sx={{
            position: "absolute",
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50% )',
            width: 500,
            
            p: 4,
          }}
        >
          <Paper style={{ padding: '10px', backgroundColor: '#4c4c4cff', color: 'black', textAlign: 'center', fontSize: '16px' }}>
            {fornecedorSelecionar && (
              <div className="fornecedor-info">
                <h3>Informações do Fornecedor</h3>
                <p>Nome: {fornecedorSelecionar.nomeEmpresa}</p>
                <p>Telefone: {fornecedorSelecionar.telefone}</p>
                <p>CNPJ: {fornecedorSelecionar.cnpj}</p>
                <p>Email: {fornecedorSelecionar.email}</p>
                <p>Endereço: {fornecedorSelecionar.endereco}</p>
              </div>
            )}
            <Button onClick={handleCloseFornecedorModal} variant="contained">Fechar</Button>
          </Paper>
        </Box>
      </Modal>
      <Snackbar
        open={snackbarOpen}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message={popperMessage}
      />
    </div>
  );
};
export default MateriaPrima;